import { compose } from 'recompose';

import ContactShow from './ContactShow';

const enhance = compose();

export default enhance(ContactShow);
